import angular from 'angular';
import {
  ssDialogService,
  loaderService,
  reportsDataService
} from 'app/services';
import {
  alerts,
  actionIcon
} from 'app/components/global';
import controller from './generate-report-dialog.controller';
import template from './generate-report-dialog.html';


export class dialogService {
  getOptions($event, { report = null, serviceId, reportGroupId, }) {
    return {
      controller,
      controllerAs: 'srGenerateReportDialogVM',
      locals: {
        report,
        serviceId,
        reportGroupId,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.reports.generateReportDialog', [
  ssDialogService,
  loaderService,
  reportsDataService,
  alerts,
  actionIcon
])
  .service('generateReportDialog', dialogService)
  .name;

console.log('app.components.reports.generateReportDialog created');
